import { render, staticRenderFns } from "./JtNewSelect.vue?vue&type=template&id=48f863af&scoped=true"
import script from "./JtNewSelect.vue?vue&type=script&lang=js"
export * from "./JtNewSelect.vue?vue&type=script&lang=js"
import style0 from "./JtNewSelect.vue?vue&type=style&index=0&id=48f863af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f863af",
  null
  
)

export default component.exports